import { render, staticRenderFns } from "./AnnualReturnFormFiles.vue?vue&type=template&id=ad1c0d12&scoped=true&"
import script from "./AnnualReturnFormFiles.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnFormFiles.vue?vue&type=style&index=0&id=ad1c0d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1c0d12",
  null
  
)

export default component.exports